import { ITargetsData, ITargetsParams, ITargetsResponse } from '@cian/adfox/build/api';
import { memoizedFetch } from '@cian/adfox/build/utils/fetch';

// тип баннера (указывается в коде шаблона)
export type AdFoxBannerType =
  | 'mortgage'
  | 'seo'
  | 'stretch'
  | 'contract'
  | 'mortgage_offer_card_banner'
  | 'offer_card_image_banner'
  | 'mortgage_in_rent';

export interface IBanners {
  [key: string]: {
    [key: string]: string;
  };
}

export type BANNER_TEMPLATE_TYPE =
  | 'mortgage'
  | 'seo'
  | 'stretch'
  | 'contract'
  | 'mortgage_offer_card_banner'
  | 'offer_card_image_banner'
  | 'mortgage_in_rent';

const banners: IBanners = {
  contract: {
    p1: 'bvebl',
    p2: 'fjuj',
  },
  mortgage: {
    p1: 'byelt',
    p2: 'fkib',
  },
  seo: {
    p1: 'bvkkh',
    p2: 'fkhh',
    pct: 'b',
    pfb: 'a',
    pfc: 'a',
    pli: 'a',
    plp: 'a',
    pop: 'a',
    pt: 'b',
  },
  stretch: {
    p1: 'bvknz',
    p2: 'y',
  },
  mortgage_offer_card_banner: {
    p1: 'byelt',
    p2: 'fkib',
  },
  offer_card_image_banner: {
    p1: 'byelt',
    p2: 'fkib',
  },
  mortgage_in_rent: {
    p1: 'byelt',
    p2: 'fkib',
  },
};

function prepareParams(params: ITargetsParams) {
  const baseUrl = params['baseUrl'] || '/';

  const query: ITargetsParams = Object.assign({}, params);
  delete query['baseUrl'];

  return {
    baseUrl,
    query,
  };
}

export function offerRequest(params: ITargetsParams): Promise<ITargetsResponse> {
  const { baseUrl, query } = prepareParams(params);

  return memoizedFetch<ITargetsData>({
    query,
    url: baseUrl + 'cian-api/site/v1/adfox/offer/',
  });
}

export function getBannerByType(type: AdFoxBannerType) {
  return banners[type];
}
